const defaultCategory = {
  name: "",
  code: "",
  poredak: null,
  parent: null,
  prilog: false,
  main_group: false,
};

export { defaultCategory };
